import { createSlice } from '@reduxjs/toolkit';
interface guarantorInfo {
    guarantorTitle: string;
    guarantorKey: string;
}

const initialState: guarantorInfo = {
    guarantorTitle: '',
    guarantorKey: '',
};

export const guarantorInfoSlice = createSlice({
    name: 'guarantorInfo',
    initialState,
    reducers: {
        setGuarantorInfo: (state: any, action: any) => {
            state.guarantorTitle = action.payload.guarantorTitle;
            state.guarantorKey = action.payload.guarantorKey;
        },
    },
});

// this is for dispatch
export const { setGuarantorInfo }: any = guarantorInfoSlice.actions;

// this is for configureStore
export default guarantorInfoSlice.reducer;
